import { render, staticRenderFns } from "./TenantWindow.vue?vue&type=template&id=72c66e83&scoped=true&"
import script from "./TenantWindow.vue?vue&type=script&lang=js&"
export * from "./TenantWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c66e83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72c66e83')) {
      api.createRecord('72c66e83', component.options)
    } else {
      api.reload('72c66e83', component.options)
    }
    module.hot.accept("./TenantWindow.vue?vue&type=template&id=72c66e83&scoped=true&", function () {
      api.rerender('72c66e83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysMenu/TenantWindow.vue"
export default component.exports